import axios from 'axios'

const headers = { Authorization: localStorage.getItem('jwt') }

export const authApi = axios.create({
	baseURL: process.env.VUE_APP_AUTH_API,
})

export const ordemServicoApi = axios.create({
	baseURL: process.env.VUE_APP_ORDEM_SERVICO_API,
	headers,
})

export const registryApi = axios.create({
	baseURL: process.env.VUE_APP_REGISTRY_API,
	headers,
})

export const walterApi = axios.create({
	baseURL: process.env.VUE_APP_WALTER_API,
	headers,
})

export const walterBIApi = axios.create({
	baseURL: process.env.VUE_APP_WALTER_BI_API,
	headers,
})

export const integracoesApi = axios.create({
	baseURL: process.env.VUE_APP_INTEGRACOES_API,
	headers,
})

export const treeviaGateway = axios.create({
	baseURL: process.env.VUE_APP_APIGATEWAY,
	headers,
})

export const classificacaoSitioApi = axios.create({
	baseURL: process.env.VUE_APP_CLASSIFICACAO_DE_SITIO_MODELOS,
	headers,
})

export const prognoseApi = axios.create({
	baseURL: process.env.VUE_APP_PROGNOSE_MODELOS,
	headers,
})

export const climateApi = axios.create({
	baseURL: process.env.VUE_APP_CLIMATE_API,
})

export const academyApi = axios.create({
	baseURL: process.env.VUE_APP_TREEVIA_ACADEMY_API,
})

export const smartForestApi = axios.create({
	baseURL: process.env.VUE_APP_INTEGRACOES_API,
	headers,
})

/**
 * Metodo para setar os authorization apos realizar login de usuario, o metodo e necessario
 * pois a variavel headers criada anteriormente nao e atualizada automaticamente com o jwt vindo do localstorage
 * sendo necessario atualizar atraves da chamada deste metodo
 */
export const setAuthorizationAfterLogin = () => {
	climateApi.defaults.headers.Authorization = localStorage.getItem('jwt')
	authApi.defaults.headers.Authorization = localStorage.getItem('jwt')
	ordemServicoApi.defaults.headers.Authorization = localStorage.getItem('jwt')
	registryApi.defaults.headers.Authorization = localStorage.getItem('jwt')
	walterApi.defaults.headers.Authorization = localStorage.getItem('jwt')
	walterBIApi.defaults.headers.Authorization = localStorage.getItem('jwt')
	treeviaGateway.defaults.headers.Authorization = localStorage.getItem('jwt')
	integracoesApi.defaults.headers.Authorization = localStorage.getItem('jwt')
	prognoseApi.defaults.headers.Authorization = localStorage.getItem('jwt')
	classificacaoSitioApi.defaults.headers.Authorization = localStorage.getItem('jwt')
	academyApi.defaults.headers.Authorization = localStorage.getItem('jwt')
	smartForestApi.defaults.headers.Authorization = localStorage.getItem('jwt')
}
